const Home = () => {
    return (
        <div>
            <h1>A summary of crash data in Illinois from 2016 to 2022</h1>
            <p>You could select either ZIP Map or Block Group Map on top to view the choropleth map based on the selected division type.</p>
        </div>
    )
};

export default Home;